import { render, staticRenderFns } from "./ModalGallery.vue?vue&type=template&id=387c981e&scoped=true"
import script from "./ModalGallery.vue?vue&type=script&lang=js"
export * from "./ModalGallery.vue?vue&type=script&lang=js"
import style0 from "./ModalGallery.vue?vue&type=style&index=0&id=387c981e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387c981e",
  null
  
)

export default component.exports